import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Text } from '@zinc/ui';
import TerminalPaymentDialogStore from 'bz-core-controls/controls/payments/shared/terminal-payment-dialog/stores/terminal-payment-dialog-store';
import type React from 'react';
import { useEffect, useMemo, useState } from 'react';

interface IProps {}

const TerminalModalCountdown: React.FC<IProps> = () => {
  const { FAIL_TIMER } = TerminalPaymentDialogStore;
  const [timeLeft, setTimeLeft] = useState(FAIL_TIMER / 1000);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = useMemo(() => {
    return (seconds: number) => {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };
  }, [timeLeft]);

  return (
    <Alert icon={<FontAwesomeIcon icon={faCircleExclamation} size="xl" />} color={'warning'}>
      <Text color="warning">Payment Link will expire in: {formatTime(timeLeft)}</Text>
    </Alert>
  );
};

TerminalModalCountdown.displayName = 'TerminalModalCountdown';

export default TerminalModalCountdown;
